/** Shared with the client so old inbound links keep the same destinations. */
/** @type {Record<string, string>} */
export const SHOPIFY_PAGE_REDIRECTS = {
  "about-us": "/about",
  "meet-the-writers": "/about",
  speaking: "/about",
  "statement-of-faith": "/statement-of-faith",
  "curriculum-quiz": "/curriculum-quiz",
  "build-your-own-curriculum": "/build-bundle",
  store: "/shop",
  products: "/shop",
  "volume-2": "/products/whole-life-discipleship-volume-2",
  wld: "/wld",
  "in-the-trenches": "/blog",
};

/** @type {Record<string, string>} */
export const SHOPIFY_PRODUCT_REDIRECTS = {
  "whole-life-discipleship-curriculum-volume-3": "/wld",
  "chosen-finding-your-path-in-faith": "/products/wld-vol-1",
  "love-logics": "/products/wld-vol-1",
};

export const SHOPIFY_PAGE_EXTERNAL = new Set([
  "privacy-policy", "terms-of-service", "refund-policy", "cookie-policy",
  "disclaimer", "data-sharing-opt-out", "avada-faqs",
]);

const appPages = new Set([
  "/", "/about", "/statement-of-faith", "/shop", "/wld", "/blog",
  "/setup", "/dashboard", "/admin", "/admin-setup", "/tools",
  "/self-assessment", "/ministry-survey", "/curriculum-quiz", "/build-bundle",
  "/assessment", "/suggestions", "/first-aid-kit",
]);

// Public product/blog slugs are checked against actual prerenders by the server,
// not accepted as arbitrary SPA paths (which would reintroduce soft 404s).
export function isAppRoute(pathname) {
  return appPages.has(pathname)
    || /^\/(?:sign-in|sign-up|admin-login|curriculum|training|apps|a)(?:\/.*)?$/.test(pathname)
    || /^\/admin\/course-preview\/[^/]+$/.test(pathname)
    || /^\/(?:preview|survey)\/[^/]+$/.test(pathname);
}

export function legacyDestination(pathname, query = "") {
  const segments = pathname.split("/");
  const handle = segments[2] || "";
  let destination;
  if (segments[1] === "pages") {
    if (SHOPIFY_PAGE_EXTERNAL.has(handle)) {
      destination = `https://reframeyouth.myshopify.com/pages/${handle}?_fd=0`;
    } else {
      destination = SHOPIFY_PAGE_REDIRECTS[handle] || `/${handle}`;
    }
  } else if (segments[1] === "collections") {
    destination = handle === "wld" || handle === "volume-2" ? "/wld" : "/shop";
  } else if (segments[1] === "blogs") {
    destination = segments.length === 4 && segments[3] ? `/blog/${segments[3]}` : "/blog";
  } else if (segments[1] === "policies" && handle && segments.length === 3) {
    destination = `https://reframeyouth.myshopify.com/policies/${handle}?_fd=0`;
  } else if (["cart", "series"].includes(segments[1]) || pathname === "/search") {
    destination = "/shop";
  } else if (segments[1] === "account") {
    destination = "/";
  } else if (segments[1] === "products" && segments.length === 3) {
    destination = SHOPIFY_PRODUCT_REDIRECTS[handle];
  }
  if (!destination) return null;
  // Keep original attribution/query bytes. _fd=0 prevents a Shopify bounce.
  return destination + (query ? `${destination.includes("?") ? "&" : "?"}${query.replace(/^\?/, "")}` : "");
}

/** Exact host matching intentionally excludes Replit preview/deployment hosts. */
export function redirectLocation(host, requestUrl) {
  // Do not turn a malformed request target into a protocol-relative redirect.
  if (!requestUrl.startsWith("/") || requestUrl.startsWith("//") || /[\\\r\n]/.test(requestUrl)) return null;
  const pathname = requestUrl.split("?")[0] || "/";
  const query = requestUrl.includes("?") ? requestUrl.slice(requestUrl.indexOf("?")) : "";
  if (["reframeyouth.com", "tools.reframeyouth.com"].includes(host.toLowerCase().split(":")[0])) {
    return `https://www.reframeyouth.com${pathname}${query}`;
  }
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return legacyDestination(normalized, query)
    || (pathname !== normalized ? `${normalized}${query}` : null);
}
